import { motion } from "framer-motion";
import SectionHeading from "../../SectionHeading";
import { fadeUp, revealOnce, stagger } from "../../motion";
import "../../css/Testimonials.css";

const TESTIMONIALS = [
  {
    quote:
      "Daniel is a dependable systems engineer. He handles infrastructure with real care — from endpoint management to network configuration — and consistently delivers solutions that just work. A genuine asset to any technical team.",
    name: "Olalekan Ahmed",
    role: "Head, IT & Systems Engineering",
    company: "Netcom Africa Limited",
  },
  {
    quote:
      "What stands out about Daniel is how calmly he solves problems. He's quick to understand an issue, thorough in his approach, and great with end users. Our support operations ran noticeably smoother with him on board.",
    name: "Elvis Okolo",
    role: "Head, IT Support Department",
    company: "Summitech Computing Limited",
  },
  {
    quote:
      "Daniel bridges IT systems and software in a way that's rare. He understands the business need behind the technology and builds for it. Reliable, sharp, and always willing to go the extra mile.",
    name: "Moses Mornu",
    role: "Head, IT & Business Innovation",
    company: "CWG PLC",
  },
];

const initials = (name) =>
  name
    .split(" ")
    .map((n) => n[0])
    .slice(0, 2)
    .join("");

const Testimonials = () => {
  return (
    <section className="section testimonials">
      <div className="container">
        <SectionHeading
          eyebrow="Testimonials"
          title="What colleagues say"
        />

        <motion.div
          className="testimonials__grid"
          variants={stagger}
          {...revealOnce}
        >
          {TESTIMONIALS.map((t) => (
            <motion.figure key={t.name} className="testimonial" variants={fadeUp}>
              <span className="testimonial__quote-mark" aria-hidden="true">
                &ldquo;
              </span>
              <blockquote className="testimonial__quote">{t.quote}</blockquote>
              <figcaption className="testimonial__author">
                <span className="testimonial__avatar">{initials(t.name)}</span>
                <span>
                  <span className="testimonial__name">{t.name}</span>
                  <span className="testimonial__role">
                    {t.role} · {t.company}
                  </span>
                </span>
              </figcaption>
            </motion.figure>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default Testimonials;
